module.exports = __webpack_public_path__ + "img/54600.1f8b2594.jpg";